'use strict';

export const LOADING = 0;
export const LOADED = 1;
export const NO_DATA = 2;
export const NO_NETWORK = 3;
export const PLACEHOLDER = 4; // Used for custom placeholders

export function getValue(mode) {
  switch (mode) {
    case LOADING:
      return 'LOADING';
    case LOADED:
      return 'LOADED';
    case PLACEHOLDER:
      return 'PLACEHOLDER';
    case NO_DATA:
      return 'NO_DATA';
    case NO_NETWORK:
      return 'NO_NETWORK';
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/loading-states.js